<template>
  <div>
    <div>
      <div style="overflow: hidden" @click="UploadImg">
        <v-card
          flat
          v-model="svgBackground"
          style="overflow: hidden;background-color:white"
          v-if="Src == null"
           height="112px" width="115px" 
          
        >
          <div
            class=" mt-7 d-flex justify-center"
            style="position: relative; "
            
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="29"
              height="28"
              viewBox="0 0 29 28"
              fill="none"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M3.50098 0.666504H25.501C27.0198 0.666504 28.251 1.86041 28.251 3.33317V24.6665C28.251 26.1393 27.0198 27.3332 25.501 27.3332H3.50098C1.98219 27.3332 0.750977 26.1393 0.750977 24.6665V3.33317C0.750977 1.86041 1.98219 0.666504 3.50098 0.666504ZM3.5009 3.3332V18.7811L9.00107 13.4476L13.8135 18.1142L22.751 9.44754L25.5009 12.1141V3.3332H3.5009ZM3.5009 24.6665V22.5523L9.00107 17.2188L16.6815 24.6665H3.5009ZM25.5009 24.6665H20.5706L15.758 19.9998L22.751 13.2188L25.5009 15.8854V24.6665ZM17.251 8.66649C17.251 6.45735 15.4041 4.66649 13.1259 4.66649C10.8478 4.66649 9.00095 6.45735 9.00095 8.66649C9.00095 10.8756 10.8478 12.6665 13.1259 12.6665C15.4041 12.6665 17.251 10.8756 17.251 8.66649ZM11.751 8.66652C11.751 7.93014 12.3666 7.33319 13.126 7.33319C13.8854 7.33319 14.501 7.93014 14.501 8.66652C14.501 9.4029 13.8854 9.99985 13.126 9.99985C12.3666 9.99985 11.751 9.4029 11.751 8.66652Z"
                fill="#73788C"
              />
            </svg>
       
          </div>
        <div class="image_cardd d-flex justify-center mt-2">
          Upload image
        </div>
        <div class="image_cardd d-flex justify-center">
        300x300 px
        </div>
        </v-card>

        <v-card v-model="UploadedImage" v-else>
          <v-img :src="Src" ref="Image" style="height: 100%" contain></v-img>
        </v-card>
      </div>

      <input type="file" style="display: none" ref="Img" @change="SetImage" />
    </div>
  </div>
</template>

<script>
export default {
  name: "HelpcenterImageUploaderComponent",

  data() {
    return {
      svgBackground: true,
      UploadedImage: false,

      SingleImage: {},
      img: {},
      cropper: {},
      destination: {},
      Src: null,
    };
  },
  mounted() {},
  methods: {
    UploadImg() {
      this.$refs.Img.click();
    },
    SetImage() {
      var reader = new FileReader();
      reader.onload = () => {
        this.Src = reader.result;
        this.$refs.Image.src = reader.result;
      };
      reader.readAsDataURL(this.$refs.Img.files[0]);
    },
  },
};
</script>

<style scoped>
h1 {
  font-family: "DM Sans";
  font-size: 30px;
  font-weight: 400;
  line-height: 39px;
}
.check {
  background-image: url("../../assets/css/rect.svg");
  background-repeat: no-repeat;
  background-size: contain;
  display: flex;
  align-items: center;
}
.image_cardd
{
  font-family: 'DM Sans';
font-style: normal;
font-weight: 400;
font-size: 12px;
line-height: 19px;
text-align: center;
letter-spacing: 0.0025em;

color: #73788C;
}
</style>
